import { useState, useEffect } from 'react';

export const useTypewriter = (text, speed = 30) => {
    const [displayedText, setDisplayedText] = useState('');
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        if (!text) {
            setDisplayedText('');
            setIsComplete(false);
            return;
        }

        let cancelled = false;
        let index = 0;
        let timeoutId = null;

        setDisplayedText('');
        setIsComplete(false);

        const tick = () => {
            if (cancelled) {
                return;
            }

            index += 1;
            setDisplayedText(text.slice(0, index));

            if (index >= text.length) {
                setIsComplete(true);
                return;
            }

            timeoutId = setTimeout(tick, speed);
        };

        timeoutId = setTimeout(tick, speed);

        return () => {
            cancelled = true;
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [text, speed]);

    return { displayedText, isComplete };
};
